module.exports = __webpack_public_path__ + "static/tridyme-default-image-060c694840f2757e74bd8c9f0a55ff13.png";